
  import React from "react"
  import Component from "/var/www/html/src/layouts/en.js"
  import data from "/var/www/html/.cache/json/layout-en.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/en.js